import { parseAbsoluteToLocal } from "@internationalized/date";

/**
 * Appends a Z suffix to ISO date strings that carry no timezone information,
 * so API dates without a suffix are treated as UTC.
 */
export const normalizeApiDate = (dateStr: string): string => {
	const hasTimezone = dateStr.endsWith("Z") || /[+-]\d{2}:?\d{2}$/.test(dateStr);
	return hasTimezone ? dateStr : `${dateStr}Z`;
};

/**
 * Parses an ISO date string from the API and returns a Date object in local time.
 * Handles the case where the API returns dates without timezone suffix (Z).
 */
export const parseApiDate = (dateStr: string): Date => {
	const zdt = parseAbsoluteToLocal(normalizeApiDate(dateStr));
	return new Date(zdt.year, zdt.month - 1, zdt.day, zdt.hour, zdt.minute, zdt.second);
};

/**
 * Parses an ISO date string from the API and returns a ZonedDateTime in local time.
 * Useful when you need the individual components (year, month, day, hour, minute).
 */
export const parseApiDateToLocal = (dateStr: string) => {
	return parseAbsoluteToLocal(normalizeApiDate(dateStr));
};
